import { ICommonResponse, IDictionaryItem } from 'api/types';
import { IRootState } from 'reducers';
import { createSelector } from 'reselect';
import { sectionRefArchiveFalseSelector } from 'selectors/reference';
import { filterParentSectionRefCodes, sortParentSectionRefCodes } from 'utils';

const parentSectionsArchiveFalseSelector = createSelector(
  [(state: IRootState) => sectionRefArchiveFalseSelector(state)],
  (sections): ICommonResponse<IDictionaryItem> => {
    const parentSections = sections.content.filter((section) => filterParentSectionRefCodes(section.code));
    const sortedSections = parentSections.sort((a, b) => sortParentSectionRefCodes(a.code, b.code));

    return {
      ...sections,
      content: sortedSections,
    };
  },
);

export default parentSectionsArchiveFalseSelector;
